import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Checkbox, ConfigProvider, Result, Select, DatePicker, notification, Alert, Radio } from 'antd';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import { CheckCircleFilled, InfoCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/es_ES';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import changeHeight from '../data/changeHeight';

const FormComplementoPaternidadPago = () => {
    const [buttonLoading, setbuttonLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [primaryColor, setPrimaryColor] = useState('#FFFFFF');
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const refForm = useRef(0);
    const refResult = useRef(0);
    const [result, setResult] = useState("collapse");
    const [heightResult, setHeightResult] = useState(0);
    const [api, contextHolder] = notification.useNotification();
    const [alertAnoJubilacion, setAlertAnoJubilacion] = useState("");
    const [alertHijos, setAlertHijos] = useState(false);
    const [mostrarPreguntaAdicional, setMostrarPreguntaAdicional] = useState(false);
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [alertGenero, setAlertGenero] = useState(false);
    const [soloContacto, setSoloContacto] = useState(false);

    useEffect(() => {
        if (searchParams.get("primaryColor")) {
            setPrimaryColor('#' + searchParams.get("primaryColor"));
            setResult("none");
            setHeightResult(refResult.current.clientHeight);
        }
        if (searchParams.get("parentUrl")) {
            form.setFieldsValue({ url: searchParams.get("parentUrl") });
        }
    }, [searchParams, form]);

    useEffect(() => {
        const formEl = refForm.current;
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === formEl) {
                    changeHeight(entry.target.clientHeight);
                    break;
                }
            }
        });

        resizeObserver.observe(formEl);

        return () => {
            resizeObserver.unobserve(formEl);
        };
    }, []);

    window.addEventListener('message', (event) => {
        if (event.data.type === "from-parent") {
            if (event.data.fbp === 'null' || event.data.fbp === null || event.data.fbp === undefined) {
                form.setFieldsValue({ fbp: " " });
            } else {
                form.setFieldsValue({ fbp: event.data.fbp });
            }
            if (event.data.hubspotutk === 'null' || event.data.hubspotutk === null || event.data.hubspotutk === undefined) {
                form.setFieldsValue({ hubspotutk: " " });
            } else {
                form.setFieldsValue({ hubspotutk: event.data.hubspotutk });
            }
            if (event.data.userAgent) { form.setFieldsValue({ userAgent: event.data.userAgent }); }
            changeHeight(refForm.current.clientHeight);
        }
    });

    const onFinish = (values) => {
        setbuttonLoading(true);
        // Caso especial: si el periodo es "despues2021", se comporta como Brecha Género (solo toma de datos)
        if (values.periodo_jubilacion === 'despues2021') {
            values.url = values.url + "?brecha-genero";
            // ano_jubilacion viene del DatePicker (month)
            values.ano_jubilacion = values.ano_jubilacion.format('MMMM YYYY');
        } else {
            // Flujo original de paternidad
            if (values.periodo_jubilacion === '2016a2021') {
                values.ano_jubilacion = 'Entre 2016 y 2021';
            } else if (values.periodo_jubilacion === 'despues2021') {
                values.ano_jubilacion = '2022 o posterior';
            } else {
                values.ano_jubilacion = values.periodo_jubilacion;
            }
            // No se envía periodo_jubilacion en el flujo original
            delete values.periodo_jubilacion;
            values.url = values.url + "?paternidad";
        }
        axios.post(`${process.env.REACT_APP_URL_PRIMA_UNICA}`, values)
            .then(function (response) {
                if (response.data.message === "OK") {
                    setbuttonLoading(false);
                    setSuccess(true);
                    setResult("block");
                    changeHeight(heightResult);
                }
            })
            .catch(function () {
                openNotification('bottom');
                setbuttonLoading(false);
            });
    };

    const onChangeTipoJubilacion = (value) => {
        if (value === 'Anticipada') {
            setMostrarPreguntaAdicional(true);
            setMostrarAlerta(false); // Resetear la alerta en caso de que el usuario cambie su selección
        } else {
            setMostrarPreguntaAdicional(false);
            setMostrarAlerta(false);
        }
    };

    const onChangePreguntaAdicional = (value) => {
        if (value === 'Voluntaria') {
            setMostrarAlerta(true);
        } else {
            setMostrarAlerta(false);
        }
    };

    const openNotification = (placement) => {
        api.info({
            message: 'Error inesperado',
            description:
                'Ha ocurrido un error inesparado. Intentelo más tarde. Disculpe las molestias',
            placement,
            icon: (
                <CloseCircleOutlined style={{ color: "#f7151c" }} />
            )
        });
    };

    const onChangeAnoJubilacion = (value) => {
        if (value === "antes2016") {
            setAlertAnoJubilacion('antes2016');
            setSoloContacto(false);
        } else if (value === "2016a2021") {
            setAlertAnoJubilacion('');
            setSoloContacto(false);
        } else if (value === "despues2021") {
            setAlertAnoJubilacion('despues2021');
            setSoloContacto(false);
        } else {
            setAlertAnoJubilacion('');
            setSoloContacto(false);
        }
    }

    const onChangeHijos = (value) => {
        if (value === "0" || value === "1") {
            setAlertHijos(true);
        } else {
            setAlertHijos(false);
        }
    }

    const onChangeGenero = (value) => {
        if (value !== 'Hombre') {
            setAlertGenero(true);
        } else {
            setAlertGenero(false);
        }
    }

    const subtitleText = "Tu información ha sido enviada correctamente.<br/>En breve nos pondremos en contacto contigo, pero recuerda que puedes concertar una cita haciendo clic en el siguiente botón.";

    return (
        <>
            {contextHolder}
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                <style>
                    {`
                    ::-webkit-scrollbar {
                        display: none;
                    }
                    `}
                </style>
                <div ref={refForm}>
                    <Form
                        form={form}
                        style={{ padding: '1rem' }}
                        hidden={success}
                        name="basic"
                        initialValues={{ remember: true }}
                        layout='vertical'
                        onFinish={onFinish}
                    >
                        <Form.Item hidden={true} label="URL" name="url">
                            <Input type='text' />
                        </Form.Item>
                        <Form.Item hidden={true} label="FB" name="fbp">
                            <Input type='' />
                        </Form.Item>
                        <Form.Item hidden={true} label="Hubspotutk" name="hubspotutk">
                            <Input type='' />
                        </Form.Item>
                        <Form.Item
                            style={{ marginBottom: "0.6rem" }}
                            label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿En qué periodo te jubilaste?</p>}
                            name="periodo_jubilacion"
                            rules={[{ required: true, message: 'Por favor, escoge un periodo' }]}
                        >
                            <Select
                                showSearch
                                placeholder='Escoge un periodo'
                                disabled={buttonLoading}
                                onChange={(value) => { onChangeAnoJubilacion(value); }}
                                value={form.getFieldValue('periodo_jubilacion')}
                            >
                                <Select.Option key="antes2016" value="antes2016">Antes del 3 de febrero de 2016</Select.Option>
                                <Select.Option key="2016a2021" value="2016a2021">Entre el 3 de febrero de 2016 y el 3 de febrero de 2021</Select.Option>
                                <Select.Option key="despues2021" value="despues2021">Después del 3 de febrero de 2021</Select.Option>
                            </Select>
                        </Form.Item>
                        <div style={{ display: `${alertAnoJubilacion === 'antes2016' ? "block" : "none"}` }}>
                            <Alert style={{ marginTop: "3%", marginBottom: "3%" }} message="Si te jubilaste antes del 3 de febrero de 2016, lamentablemente, no eres elegible para reclamar el complemento de paternidad." type="error" />
                        </div>
                        <div style={{ display: `${alertAnoJubilacion === 'despues2021' ? "block" : "none"}` }}>
                            <Alert
                                style={{ marginTop: "3%", marginBottom: "3%" }}
                                message={
                                    <span>
                                        No puedes acogerte al complemento de paternidad.<br />
                                        Si te jubilaste entre el 1 de enero de 2016 y el 3 de febrero de 2021,{' '}
                                        <a href="https://www.coventia.es/solicitar-complemento-brecha-genero" target="_blank" rel="noopener noreferrer">
                                            rellena nuestro formulario para pedir el complemento por brecha de género
                                        </a>.
                                    </span>
                                }
                                type="info"
                            />
                        </div>
                        {/* Cuando es despues2021, comportarse como Brecha Género (solo toma de datos) */}
                        {alertAnoJubilacion === 'despues2021' && (
                            <>
                                <Form.Item
                                    style={{ marginBottom: "1.2rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "-3px", marginBottom: "3px" }}>¿Cuál es tu género?</p>}
                                    name="genero"
                                    rules={[{ required: true, message: 'Por favor, escoge una opción' }]}
                                >
                                    <Radio.Group disabled={buttonLoading} onChange={e => onChangeGenero(e.target.value)}>
                                        <Radio value="Mujer">Mujer</Radio>
                                        <Radio value="Hombre">Hombre</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <div style={{ display: `${alertGenero ? "block" : "none"}` }}>
                                    <Alert
                                        style={{ marginTop: "5%", marginBottom: "5%" }}
                                        message="Si eres mujer, la Seguridad Social te habrá aplicado el complemento de brecha de género automáticamente. No es necesario que rellenes este formulario."
                                        type="info"
                                    />
                                </div>

                                <Form.Item
                                    style={{ marginBottom: "1.2rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "-3px", marginBottom: "3px" }}>¿Cuántos hijos tienes?</p>}
                                    name="hijos"
                                    rules={[{ required: true, message: 'Por favor, escoge una opción' }]}
                                >
                                    <Select showSearch placeholder='Escoge una cifra' disabled={buttonLoading}>
                                        <Select.Option key="1" value="1">1</Select.Option>
                                        <Select.Option key="2" value="2">2</Select.Option>
                                        <Select.Option key="3" value="3">3</Select.Option>
                                        <Select.Option key="4 o más" value="4 o más">4 o más</Select.Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "1.2rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "-3px", marginBottom: "3px" }}>¿En qué mes y año te jubilaste?</p>}
                                    name="ano_jubilacion"
                                    rules={[{ required: true, message: 'Por favor, selecciona el mes y año de jubilación' }]}
                                    getValueFromEvent={value => value ? dayjs(value) : null}
                                >
                                    <DatePicker
                                        picker="month"
                                        style={{ width: '100%', height: '38px' }}
                                        disabled={buttonLoading}
                                        format="MMMM YYYY"
                                        showToday={false}
                                        renderExtraFooter={() => null}
                                        locale={locale}
                                        onChange={value => {
                                            form.setFieldsValue({ ano_jubilacion: value });
                                        }}
                                        disabledDate={current => {
                                            const minDate = dayjs('2021-02-01');
                                            const maxDate = dayjs().endOf('month');
                                            return current && (current < minDate || current > maxDate);
                                        }}
                                    />
                                    <div style={{ fontSize: '13px', color: '#888', marginTop: 8, marginBottom: 5 }}>
                                        Puedes hacer clic en el año para cambiarlo y seleccionar cualquier mes desde febrero de 2021.
                                    </div>
                                </Form.Item>
                            </>
                        )}
                        {/* El resto de campos solo si NO es despues2021 */}
                        {!soloContacto && alertAnoJubilacion !== 'despues2021' && (
                            <>
                                <Form.Item
                                    style={{ marginBottom: "0.6rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Cuál es tu género?</p>}
                                    name="genero"
                                    rules={[{ required: true, message: 'Por favor, escoge una opción' }]}
                                >
                                    <Radio.Group
                                        showSearch
                                        placeholder='Escoge una opción'
                                        disabled={buttonLoading}
                                        onChange={(e) => onChangeGenero(e.target.value)}>
                                        <Radio value="Hombre">Hombre</Radio>
                                        <Radio value="Mujer">Mujer</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <div style={{ display: `${alertGenero ? "block" : "none"}` }}>
                                    <Alert style={{ marginTop: "3%", marginBottom: "3%" }} message="Lamentablemente, para continuar el reclamante debe ser hombre." type="error" />
                                </div>

                                <Form.Item
                                    style={{ marginBottom: "0.6rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Cuántos hijos tienes?</p>}
                                    name="hijos"
                                    rules={[{ required: true, message: 'Por favor, escoge una opción' }]}
                                >
                                    <Select showSearch placeholder='Escoge una cifra' disabled={buttonLoading} onChange={onChangeHijos}>
                                        <Select.Option key="0" value="0">0</Select.Option>
                                        <Select.Option key="1" value="1">1</Select.Option>
                                        <Select.Option key="2" value="2">2</Select.Option>
                                        <Select.Option key="3" value="3">3</Select.Option>
                                        <Select.Option key="4 o más" value="4 o más">4 o más</Select.Option>
                                    </Select>
                                </Form.Item>

                                <div style={{ display: `${alertHijos ? "block" : "none"}` }}>
                                    <Alert style={{ marginTop: "3%", marginBottom: "3%" }} message="Lamentablemente, para reclamar el complemento de paternidad, es necesario tener al menos dos hijos." type="error" />
                                </div>

                                <Form.Item
                                    style={{ marginBottom: "0.6rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Qué tipo de jubilación obtuviste?</p>}
                                    name="tipo_jubilacion"
                                    rules={[{ required: true, message: 'Por favor, escoge una opción' }]}
                                >
                                    <Select showSearch placeholder='Escoge una opción' disabled={buttonLoading} onChange={onChangeTipoJubilacion}>
                                        <Select.Option key="Ordinaria" value="Ordinaria">Jubilación ordinaria</Select.Option>
                                        <Select.Option key="Anticipada" value="Anticipada">Jubilación anticipada</Select.Option>
                                    </Select>
                                </Form.Item>

                                {mostrarPreguntaAdicional && (
                                    <Form.Item
                                        style={{ marginBottom: "0.6rem" }}
                                        label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Fue voluntaria o forzosa?</p>}
                                        name="tipo_jubilacion_anticipada"
                                        rules={[{ required: true, message: 'Por favor, escoge una opción' }]}
                                        tooltip={{ title: 'Consulta la sección "Resolvemos todas tus dudas" debajo del formulario para más información.', icon: <InfoCircleOutlined /> }}
                                    >
                                        <Radio.Group onChange={(e) => onChangePreguntaAdicional(e.target.value)} disabled={buttonLoading}>
                                            <Radio value="Voluntaria">Voluntaria</Radio>
                                            <Radio value="Forzosa">Forzosa</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                )}

                                <div style={{ display: `${mostrarAlerta ? "block" : "none"}` }}>
                                    <Alert style={{ marginTop: "3%", marginBottom: "3%" }} message="Lamentablemente no llevamos casos de jubilaciones anticipadas voluntarias" type="error" />
                                </div>
                            </>
                        )}
                        <Form.Item
                            style={{ marginBottom: "0.6rem" }}
                            label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Dónde te podemos enviar un email?</p>}
                            name="email"
                            rules={[{ required: true, message: 'Por favor, ingresa tu email' }]}
                        >
                            <Input placeholder='tunombre@email.com' type='email' disabled={buttonLoading} />
                        </Form.Item>
                        <Form.Item
                            style={{ marginBottom: "0.6rem" }}
                            label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>¿Dónde podemos llamarte?</p>}
                            name="tel"
                            rules={[{ required: true, message: 'Por favor, ingresa tu teléfono' }]}
                        >
                            <Input placeholder='919 99 31 31' type='tel' disabled={buttonLoading} maxLength={9} minLength={9} />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: "0rem" }} valuePropName="checked" name="terms" initialValue={false} rules={[{ required: true, validator: async (_, checked) => { if (!checked) { return Promise.reject(new Error("Por favor, acepta los términos y condiciones")); } } }]}>
                            <Checkbox style={{ fontSize: "15px" }} disabled={buttonLoading} >Acepto los <Link target='_blank' to='https://www.coventia.es/politica-de-privacidad-y-aviso-de-cookies'>términos y condiciones</Link></Checkbox>
                        </Form.Item>
                        <Form.Item style={{ marginBottom: "0.6rem" }} valuePropName="checked" name="whatsapp" initialValue={false}>
                            <Checkbox style={{ fontSize: "15px" }} disabled={buttonLoading} >Acepto recibir asesoramiento vía WhatsApp</Checkbox>
                        </Form.Item>
                        <Button
                            type='primary'
                            loading={buttonLoading}
                            htmlType="submit"
                            style={{ width: "100%", height: "35px" }}
                            disabled={
                                alertAnoJubilacion === 'antes2016' ||
                                (alertAnoJubilacion !== 'despues2021' && (alertHijos || mostrarAlerta || alertGenero)) ||
                                (alertAnoJubilacion === 'despues2021' && alertGenero)
                            }
                        >
                            {buttonLoading ? 'Enviando...' : 'Enviar'}
                        </Button>
                    </Form>
                </div>

                <div ref={refResult}>
                    <div style={{ display: `${result}` }}>
                        <Result
                            icon={<CheckCircleFilled style={{ color: primaryColor }} />}
                            style={{ padding: '1.5rem', paddingTop: '3rem' }}
                            status="success"
                            title="¡Gracias!"
                            subTitle={<span dangerouslySetInnerHTML={{ __html: subtitleText }} />}
                            extra={[
                                <Button type="primary" key="console" target='_blank' href='https://meetings-eu1.hubspot.com/santiago-gatti'>
                                    Haz clic para concertar una cita
                                </Button>
                            ]}
                        />
                    </div>
                </div>
            </ConfigProvider >

        </>
    );
}

export default FormComplementoPaternidadPago;